module.exports = __webpack_public_path__ + "img/Postcard_Planter_Series.6608b175.png";